import { makeStyles } from "@fluentui/react";

export const useStyles = makeStyles((theme) => ({
    wrapper:{
        padding: `20px 10px 0px`
    },
    iconButtonColor: {
        color: theme.palette.neutralDark
    },
   
    paddingTop20:{
        paddingTop:20
    }

}));